import React from 'react'
import Sidenav from '../../../navbar/Sidenav'
import { AccuracyIcon, AccuracyIcon2, AnalyticsIcon, BackIcon, categoryIconMap, ChipsetIcon, CircleTimeIcon, CloneIcon, CreditCardIcon, DatasetIcon, DeleteIcon, EditIcon, EyeIcon, EyeOffIcon, FilterIcon, HardwareIcon, HistoryIcon, HistoryTimeIcon, InfoIcon, LabelsIcon, MenuIcon, ModelEvaluationIcon, ModelTrainingIcon, PlusIcon, TableIcon, TaskCollections, TenantIcon, ToggleOffIcon, ToggleOnIcon, TrustIcon, VersionsIcon2 } from '../../../Common/SvgIcons/WorkflowIcons'
import { useLocation, useNavigate } from 'react-router-dom'
import useFetch from '../../../../components/useFetch'
import { Button } from 'reactstrap'
import '../../Admin.scss'
import getDataFromApi from '../../../../components/getDataFromApi'
import PlansBilling from './PlansBilling'
import { Skeleton } from '@mui/material'
import TitleHeader from '../../../project/header/TitleHeader'
import PathBreadcrumb from '../../../../components/PathBreadcrumb/PathBreadcrumb'

export const PlanDetails = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const role = localStorage.getItem("role");


    const [openKey, setOpenKey] = React.useState(null);
    const [statusLoading, setStatusLoading] = React.useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
    const [deleteLoading, setDeleteLoading] = React.useState(false);
    const [deleteError, setDeleteError] = React.useState(null);
    const [recommendedPlansRefreshKey, setRecommendedPlansRefreshKey] = React.useState(0);

    const Plan_Id = location?.state?.planId;
    const Tenant_Id = location?.state?.tenantId;
    const viewFrom = location?.state?.viewFrom;



    const { data, refetch, loading, setData: setPlanData } = useFetch(`admin/plan/${Plan_Id}`, 'get')

    const silentlyRefetchPlanDetails = React.useCallback(async () => {
        if (!Plan_Id) return;

        try {
            const freshPlan = await getDataFromApi(
                `${window.ENV.API_URL}/admin/plan/${Plan_Id}`,
                "get"
            );
            setPlanData(freshPlan);
        } catch (err) {
            console.error("Failed to silently refresh plan details", err);
        }
    }, [Plan_Id, setPlanData]);



    const CATEGORY_ORDER = [
        "core",
        "data",
        "labeling",
        "training",
        "evaluation",
        "deployment",
        "solutions",
        "monitoring",
    ];

    const modules = React.useMemo(() => {
        const featuresObj = data?.included_features ?? {};
        const tenantResourcesObj = data?.tenant_resources ?? {};
        const userResourcesObj = data?.user_resources ?? {};

        const featureGrouped = {};
        Object.entries(featuresObj).forEach(([featureName, feature]) => {
            const category = (feature?.category ?? "other").toLowerCase();
            if (!featureGrouped[category]) featureGrouped[category] = [];
            featureGrouped[category].push({ name: featureName, ...feature });
        });

        const resourceGrouped = {};

        Object.entries(tenantResourcesObj).forEach(([resourceName, resource]) => {
            const category = (resource?.category ?? "other").toLowerCase();
            if (!resourceGrouped[category]) resourceGrouped[category] = [];
            resourceGrouped[category].push({
                name: resourceName,
                scope: "tenant",
                ...resource,
            });
        });

        Object.entries(userResourcesObj).forEach(([resourceName, resource]) => {
            const category = (resource?.category ?? "other").toLowerCase();
            if (!resourceGrouped[category]) resourceGrouped[category] = [];
            resourceGrouped[category].push({
                name: resourceName,
                scope: "user",
                ...resource,
            });
        });

        const categories = new Set([
            ...Object.keys(featureGrouped),
            ...Object.keys(resourceGrouped),
        ]);

        const arr = [...categories].map((cat) => ({
            key: cat,
            title: cat,
            features: featureGrouped[cat] ?? [],
            resources: resourceGrouped[cat] ?? [],
            featureCount: (featureGrouped[cat] ?? []).length,
        }));

        const orderIndex = (cat) => {
            const i = CATEGORY_ORDER.indexOf(cat);
            return i === -1 ? Number.MAX_SAFE_INTEGER : i;
        };

        return arr.sort((a, b) => {
            const ai = orderIndex(a.key);
            const bi = orderIndex(b.key);
            if (ai !== bi) return ai - bi;
            return a.key.localeCompare(b.key);
        });
    }, [data]);


    const money = (n) => (typeof n === "number" ? `$${n}` : "$0");

    const prettyTitle = (s) =>
        (s ?? "")
            .toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());



    const moduleIcon = (category) => {
        const Icon = categoryIconMap[category?.toLowerCase()] || MenuIcon;

        return <Icon className="wf-icon p-1 border-0" style={{ width: 25, height: 25 }} />;
    };
    const handleStatusUpdate = (field) => {
        if (!data?._id || statusLoading) return;

        const updatedValue = !data?.[field];

        const payload = {
            [field]: updatedValue,
        };

        setStatusLoading(true);

        getDataFromApi(
            `${window.ENV.API_URL}/forms/admin/update_plan/${data._id}`,
            "post",
            payload
        )
            .then(() => {
                // ✅ Refetch fresh plan data
                refetch();
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setStatusLoading(false);
            });
    };



    const handleDeletePlan = () => {
        if (!data?._id) return;

        setDeleteLoading(true);
        setDeleteError(null);

        getDataFromApi(
            `${window.ENV.API_URL}/admin/plan/${data._id}`,
            "delete"
        )
            .then((res) => {
                setDeleteModalOpen(false);

                if (data?.is_active) {
                    setPlanData((prev) => prev ? { ...prev, is_active: false } : prev);
                    silentlyRefetchPlanDetails();
                    setRecommendedPlansRefreshKey((prev) => prev + 1);
                    return;
                }

                if (!data?.is_active) {
                    navigate("/admin/plans-billing", {
                        state: {
                            tenantId: Tenant_Id,
                        },
                    });
                }
            })
            .catch((e) => {
                setDeleteError(e?.message || "Failed to delete plan.");
            })
            .finally(() => {
                setDeleteLoading(false);
            });
    };

    if (loading) {
        return (
            <>

                <div className="mainmenu projects-content de-width h-100">
                    <PathBreadcrumb
                        onBack={() => { (viewFrom === 'TenantPlandetail' || viewFrom == 'PlansUpgrade' || viewFrom === 'PlansCurrentdetail') ? navigate(-1) : navigate('/admin/plans-billing') }}
                        items={
                            viewFrom === 'TenantPlandetail'
                                ? [
                                    { label: 'Admin', onClick: () => navigate('/admin') },
                                    { label: 'Tenant', onClick: () => navigate(-1) },
                                    { label: 'Plan' },
                                ]
                                : [
                                    { label: 'Admin', onClick: () => navigate('/admin') },
                                    { label: 'Plans', onClick: () => navigate('/admin/plans-billing') },
                                    { label: 'Plan' },
                                ]
                        }
                    />

                    <div className="d-a justify-content-between de-header-tag gap-3">
                        <div className="d-a gap-3 flex-fill">
                            <Skeleton
                                variant="rounded"
                                width={40}
                                height={40}
                                className="landing-page-main-icon flex-shrink-0"
                            />
                            <div className="title-header__copy">
                                <Skeleton variant="text" width={220} height={36} />
                                <Skeleton variant="text" width={280} height={22} className="mt-1" />
                            </div>
                        </div>
                    </div>

                    <div className='d-flex gap-4 admin-content mt-5'>
                        <div className='admin-content-card1'>
                            <section className='container-card'>
                                <div className='d-a justify-conent-between'>
                                    <div className='flex-fill'>
                                        <Skeleton variant="text" width={180} height={42} />
                                        <Skeleton variant="text" width={100} height={22} />
                                    </div>

                                    <div className='text-end'>
                                        <Skeleton variant="text" width={100} height={42} />
                                        <Skeleton variant="text" width={70} height={22} />
                                    </div>
                                </div>
                            </section>

                            <div className="admin-metric-row mt-4 pb-2">
                                {[...Array(4)].map((_, idx) => (
                                    <div
                                        key={idx}
                                        className="container-card dashboard-cards position-relative overflow-hidden"
                                        style={idx === 0 ? { borderLeft: '4px solid var(--leading-color)' } : undefined}
                                    >
                                        <Skeleton variant="circular" width={28} height={28} />
                                        <Skeleton variant="text" width={70} height={18} className="mt-3" />
                                        <Skeleton variant="text" width={36} height={22} />
                                    </div>
                                ))}
                            </div>

                            <section className='container-card mt-4'>
                                <div className='d-a gap-2'>
                                    <Skeleton variant="circular" width={24} height={24} />
                                    <Skeleton variant="text" width={170} height={24} />
                                </div>

                                <div className="mt-3 d-flex flex-column gap-3">
                                    {[...Array(4)].map((_, idx) => (
                                        <div
                                            key={idx}
                                            className="container-card"
                                            style={{ borderRadius: 16 }}
                                        >
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-start gap-3">
                                                    <Skeleton variant="rounded" width={44} height={44} />
                                                    <div>
                                                        <Skeleton variant="text" width={150} height={24} />
                                                        <Skeleton variant="text" width={100} height={18} />
                                                    </div>
                                                </div>

                                                <Skeleton variant="rounded" width={90} height={32} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>
                        </div>

                        <div className='admin-content-card2'>
                            <section className='container-card bg-main'>
                                <div className='d-flex flex-column gap-2'>
                                    <Skeleton variant="circular" width={60} height={60} />
                                    <Skeleton variant="text" width={160} height={34} className="my-2" />
                                    <Skeleton variant="text" width="100%" height={22} />
                                    <Skeleton variant="text" width="90%" height={22} />
                                    <Skeleton variant="rounded" width="100%" height={46} className="mt-4" />
                                </div>
                            </section>

                            <section className='container-card mt-4 position-relative'>
                                <Skeleton variant="text" width={170} height={28} />
                                <Skeleton variant="text" width="100%" height={12} className="mt-3 mb-3" />

                                <div className='d-a justify-conentent-between'>
                                    <div className='w-50'>
                                        <Skeleton variant="text" width={130} height={22} />
                                        <div className='d-flex align-items-end gap-2 mt-3 ms-2'>
                                            <Skeleton variant="text" width={50} height={36} />
                                            <Skeleton variant="text" width={40} height={18} />
                                        </div>
                                    </div>
                                </div>

                                <Skeleton variant="text" width={160} height={22} className="mt-5" />

                                {[...Array(4)].map((_, idx) => (
                                    <div className='mt-3 d-a justify-content-between small-font' key={idx}>
                                        <Skeleton variant="text" width={100} height={20} />
                                        <Skeleton variant="text" width={90} height={20} />
                                    </div>
                                ))}

                                <Skeleton variant="rounded" width="100%" height={44} className="mt-5" />
                                <Skeleton variant="rounded" width="100%" height={44} className="mt-3" />
                            </section>
                        </div>
                    </div>
                </div>
            </>
        );
    }



    return (
        <>

            <div className="mainmenu projects-content de-width">

                <PathBreadcrumb
                    onBack={() => { (viewFrom === 'TenantPlandetail' || viewFrom == 'PlansUpgrade' || viewFrom === 'PlansCurrentdetail') ? navigate(-1) : navigate('/admin/plans-billing') }}
                    items={
                        viewFrom === 'TenantPlandetail'
                            ? [
                                { label: 'Admin', onClick: () => navigate('/admin') },
                                { label: 'Tenant', onClick: () => navigate(-1) },
                                { label: 'Plan' },
                            ]
                            : [
                                { label: 'Admin', onClick: () => navigate('/admin') },
                                { label: 'Plans', onClick: () => navigate('/admin/plans-billing') },
                                { label: 'Plan' },
                            ]
                    }
                />



                <div className={`d-a justify-content-between pt-1 gap-3`}>
                    <TitleHeader Icon={CreditCardIcon} title1={viewFrom === 'PlansCurrentdetail' ? 'Review' : viewFrom == 'PlansUpgrade' ? 'Upgrade to' : 'Manage'} title2={data?.name} subtext={viewFrom === 'PlansCurrentdetail' ? 'Detailed overview of the current plan features, usage limits, and included entitlements.' : viewFrom == 'PlansUpgrade' ? 'Explore the full feature set and technical specifications for this configuration.' : 'Modify current plans, remove unused tiers, or upgrade for more power.'} />
                </div>



                <div className='d-flex gap-4 admin-content mt-4'>

                    <div className='admin-content-card1'>
                        <section className='container-card'>
                            <div className='d-a justify-conent-between'>
                                <div className='flex-fill'>
                                    <h2 className='fw-bold'>{data?.name}</h2>
                                    <div className='d-flex flex-wrap  align-items-start align-items-sm-center flex-column flex-sm-row gap-2 mt-1'>
                                        <span className='text-secondary text-capitalize fw-bold'>{data?.plan_type}</span>
                                    </div>
                                </div>

                                <div className='text-end'>
                                    <h1 className='fw-bold text-primary'>${data?.billing_price}</h1>
                                    <span className='fw-bold text-uppercase text-secondary'>/{data?.billing_cycle}</span>
                                </div>
                            </div>
                        </section>

                        <div className="admin-metric-row mt-4 pb-2">
                            <div
                                className="container-card dashboard-cards position-relative overflow-hidden"
                                style={{ borderLeft: '4px solid var(--leading-color)' }}
                            >
                                <TenantIcon className="wf-icon text-primary border-0" />
                                <h6 className="fw-normal mt-3 text-secondary">Plan Status</h6>
                                <h5 className="m-0 fw-bold">{data?.is_active ? 'Active' : 'Inactive'}</h5>
                                <div className="decor-circle bg-success"></div>
                            </div>

                            <div className="container-card dashboard-cards position-relative overflow-hidden">
                                <MenuIcon className="wf-icon text-primary border-0" />
                                <h6 className="fw-normal mt-3 text-secondary">Modules</h6>
                                <h5 className="m-0 fw-bold">{modules?.length ?? 0}</h5>
                                <div className="decor-circle" style={{ background: 'yellow' }}></div>
                            </div>

                            <div className="container-card dashboard-cards position-relative overflow-hidden">
                                <LabelsIcon className="wf-icon text-primary border-0" />
                                <h6 className="fw-normal mt-3 text-secondary">Features</h6>
                                <h5 className="m-0 fw-bold">{Object.keys(data?.included_features || {}).length}</h5>
                                <div className="decor-circle bg-primary"></div>
                            </div>

                            <div className="container-card dashboard-cards position-relative overflow-hidden">
                                <HardwareIcon className="wf-icon text-primary border-0" />
                                <h6 className="fw-normal mt-3 text-secondary">Resources</h6>
                                <h5 className="m-0 fw-bold">
                                    {(Object.keys(data?.tenant_resources || {}).length) +
                                        (Object.keys(data?.user_resources || {}).length)}
                                </h5>
                                <div className="decor-circle bg-success"></div>
                            </div>
                        </div>

                        {data?.is_template && role === 'system_admin' && viewFrom === '' &&
                            <section className='container-card mt-4'>
                                <div className='d-a gap-2'>
                                    <FilterIcon className='wf-icon text-primary' />
                                    <h6 className='m-0'>Plan Status & Visibility</h6>
                                </div>

                                <div className="row mt-3 g-3">
                                    <div className="col-12 col-sm-6">
                                        <div
                                            className="container-card d-a gap-2 justify-content-between cursor-pointer"
                                            onClick={() => handleStatusUpdate("is_active")}
                                        // style={{ opacity: statusLoading ? 0.6 : 1 }}
                                        >
                                            {data?.is_active ? <ToggleOnIcon className='wf-icon-green' /> : <ToggleOffIcon className='wf-icon-red' />}
                                            <div className='flex-fill'>
                                                <div className="fw-bold text-secondary mt-2 small-font">Plan Lifecycle</div>
                                                <h6>{data?.is_active ? 'Active' : 'Inactive'}</h6>
                                            </div>
                                            <span className='text-primary fw-bold small-font'>Toggle</span>
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-6">
                                        <div
                                            className="container-card d-a gap-2 justify-content-between cursor-pointer"
                                            onClick={() => handleStatusUpdate("is_public")}
                                        // style={{ opacity: statusLoading ? 0.6 : 1 }}
                                        >
                                            {data?.is_public ? <EyeIcon className='wf-icon-blue' /> : <EyeOffIcon className='wf-icon-yellow' />}
                                            <div className='flex-fill'>
                                                <div className="fw-bold text-secondary mt-2 small-font">Client Visibility</div>
                                                <h6>{data?.is_public ? 'Public' : 'Private'}</h6>
                                            </div>
                                            <span className='text-primary fw-bold small-font'>Change</span>
                                        </div>
                                    </div>
                                </div>
                            </section>}

                        <section className=' mt-4'>
                            <div className='d-a gap-2'>
                                <VersionsIcon2 className='wf-icon text-primary' />
                                <h6 className='m-0'>Module Configuration</h6>
                            </div>

                            <div className="mt-3 d-flex flex-column gap-3">
                                {modules.map((m) => {
                                    const isOpen = openKey === m.key;

                                    return (
                                        <div
                                            key={m.key}
                                            className="container-card"
                                            style={{ borderRadius: 16 }}
                                        >
                                            {/* HEADER */}
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-start gap-3">
                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: 44,
                                                            height: 44,
                                                            borderRadius: 12,
                                                            // background: "var(--card-color)",
                                                        }}
                                                    >
                                                        {moduleIcon(m.key)}
                                                    </div>

                                                    <div>
                                                        <div className="fw-bold" style={{ fontSize: 15 }}>
                                                            {prettyTitle(m.title)}
                                                        </div>
                                                        <div
                                                            className="text-secondary fw-bold text-uppercase"
                                                            style={{ fontSize: 10 }}
                                                        >
                                                            {m.featureCount} Feature{m.featureCount !== 1 ? "s" : ""} • {m.resources.length} Resource{m.resources.length !== 1 ? "s" : ""}
                                                        </div>
                                                    </div>
                                                </div>

                                                <button
                                                    type="button"
                                                    className=" plain-button  d-flex align-items-center gap-2 p-1 px-3"
                                                    style={{ width: 'unset', height: 'unset' }}
                                                    onClick={() => setOpenKey((prev) => (prev === m.key ? null : m.key))}
                                                >
                                                    View Specs
                                                    {/* <span style={{ fontSize: 14 }}>{isOpen ? "▴" : "▾"}</span> */}
                                                </button>
                                            </div>

                                            {/* EXPANDED PANEL */}
                                            {isOpen && (
                                                <div className="row mt-4">
                                                    {/* FEATURES */}
                                                    <div className="col-md-6 mb-3">
                                                        {/* ACTIVE FEATURES HEADER */}
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="text-uppercase text-secondary fw-bold" style={{ fontSize: 11 }}>
                                                                Active Features
                                                            </div>
                                                            <div className="text-primary fw-bold" style={{ fontSize: 12 }}>
                                                                {m.features.length} Items
                                                            </div>
                                                        </div>


                                                        {/* ACTIVE FEATURES LIST */}
                                                        <div className="mt-2 d-flex flex-column gap-2">
                                                            {m.features.map((f) => (
                                                                <div
                                                                    key={f.id ?? f.name}
                                                                    className="d-flex align-items-center justify-content-between container-card py-3" >
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <span
                                                                            style={{
                                                                                width: 6,
                                                                                height: 6,
                                                                                borderRadius: 999,
                                                                                background: "#4f7cff",
                                                                                display: "inline-block",
                                                                            }}
                                                                        />
                                                                        <div className="fw-semibold">{f.name}</div>
                                                                    </div>

                                                                    <div className="d-flex align-items-center gap-3">
                                                                        {/* <span
                                                                        className="text-uppercase"
                                                                        style={{
                                                                            fontSize: 10,
                                                                            padding: "2px 8px",
                                                                            borderRadius: 999,
                                                                            background: "#eef1ff",
                                                                            color: "#4f7cff",
                                                                            fontWeight: 700,
                                                                        }}
                                                                    >
                                                                        {m.key}
                                                                    </span> */}
                                                                        <div className="fw-bold">{money(f.price)}</div>
                                                                    </div>
                                                                </div>
                                                            ))}

                                                            {m.features.length === 0 && (
                                                                <div className="text-secondary" style={{ fontSize: 13 }}>
                                                                    No active features in this module.
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        {/* ASSOCIATED RESOURCES */}
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="text-uppercase text-secondary fw-bold" style={{ fontSize: 11 }}>
                                                                Associated Resources
                                                            </div>
                                                            <div className="text-primary fw-bold" style={{ fontSize: 12 }}>
                                                                {m.resources.length} Items
                                                            </div>
                                                        </div>

                                                        <div className="row g-3 mt-1">
                                                            {m.resources.map((r) => (
                                                                <div className="col-12 col-md-6" key={r.id ?? `${r.scope}-${r.name}`}>
                                                                    <div className='container-card'>
                                                                        <div className="d-flex align-items-center justify-content-between">
                                                                            <div className="text-secondary fw-bold" style={{ fontSize: 10 }}>
                                                                                {r.name}
                                                                            </div>

                                                                            {/* <span
                                                                                className="text-uppercase text-secondary fw-bold"
                                                                                style={{ fontSize: 9 }}
                                                                            >
                                                                                {r.scope}
                                                                            </span> */}
                                                                        </div>

                                                                        <div className="fw-bold mt-1 text-primary">
                                                                            {r.limit} {r.unit}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}

                                                            {m.resources.length === 0 && (
                                                                <div className="col-12">
                                                                    <div className="text-secondary" style={{ fontSize: 13 }}>
                                                                        No resources configured for this module.
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </section>
                    </div>


                    <div className='admin-content-card2'>
                        {data?.is_template && role === 'system_admin' && !Tenant_Id &&
                            <section className='container-card bg-main'>
                                <div className='d-flex flex-column gap-2'>
                                    <CloneIcon className='wf-icon-blue border-0 fw-bold text-white' style={{ width: '60px', height: '60px', background: 'rgb(88 88 88 / 22%)' }} />
                                    <h4 className='m-0 text-white fw-bold my-3'>Master Template</h4>

                                    <span className='text-white'>
                                        This plan is flagged as a system template. You can quickly initialize new service tiers using this exact configuration.
                                    </span>

                                    <Button className=' text-primary mt-4 py-3   border-0 fw-bold' style={{ background: 'white', opacity: '0.90' }}
                                        onClick={() =>
                                            navigate("/admin/create-plan", {
                                                state: {
                                                    planId: data?._id,
                                                    viewFrom: 'template',
                                                    planName: data?.name
                                                },
                                            })
                                        }>
                                        <PlusIcon className='wf-icon text-primary fw-bold' /> Create from Template
                                    </Button>
                                </div>
                            </section>}

                        {data?.is_template && role === 'system_admin' && !Tenant_Id &&
                            <section className='container-card mt-4 position-relative bg-'>
                                <h6>Tier Analytics & Lifecycle</h6>

                                <span className='mt-4 mb-3' style={{ width: '100%', height: '1px', background: 'var(--card-color)', display: 'flex' }}></span>

                                <TrustIcon style={{ width: '100px', height: '100px', position: 'absolute', right: '0', opacity: '0.07' }} />


                                <div className='d-a justify-conentent-between'>
                                    <div className='w-50'>
                                        <span className='d-a gap-2 text-primary fw-bold'><AccuracyIcon2 className='wf-icon text-primary' />Market Adoption</span>
                                        <div className='d-flex align-items-end gap-2 mt-3 ms-2'>
                                            <h6 className='m-0 fs-3'>{data?.subscription_count}</h6>
                                            <span className='fw-bold small-font text-secondary'>ORG</span>
                                        </div>
                                    </div>
                                </div>


                                <div className='mt-5 small-font fw-bold text-secondary'>
                                    Administrative Metadata
                                </div>

                                <div className='mt-3 d-a justify-content-between small-font'>
                                    <span>Plan Type</span>
                                    <span>{data?.plan_type}</span>
                                </div>

                                <div className='mt-3 d-a justify-content-between small-font'>
                                    <span>Created</span>
                                    <span>
                                        {new Date(data?.created_at).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                        })}
                                    </span>
                                </div>
                                <div className='mt-3 d-a justify-content-between small-font'>
                                    <span>Updated</span>
                                    <span>
                                        {new Date(data?.updated_at).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                        })}
                                    </span>
                                </div>

                                <div className='mt-3 d-a justify-content-between small-font'>
                                    <span>Trail Duration</span>
                                    <span>{data?.trial_duration_days ?? "0"} Days</span>
                                </div>
                                {/* <button className='d-j-a gap-1 wf-icon-blue w-100 mt-4' style={{ borderRadius: '14px' }}
                                // onClick={() =>
                                //     navigate("/admin/create-plan", {
                                //         state: {
                                //             planId: data?._id,
                                //         },
                                //     })
                                // }
                                >
                                    <EditIcon className='wf-icon text-primary' />
                                    <div className='text-primary p-0'> Edit Configuration</div>
                                </button> */}
                                <button className='d-j-a gap-1 wf-icon-red w-100 mt-4' style={{ borderRadius: '14px' }}
                                    onClick={() => { setDeleteError(null); setDeleteModalOpen(true) }}>
                                    <DeleteIcon className='wf-icon' />
                                    <div>{data?.is_active ? 'Deactivate Plan' : 'Delete Plan'}</div>
                                </button>

                            </section>}

                        {Tenant_Id &&
                            <section className='position-relative'>
                                <div className='d-a justify-content-between'>
                                    <h6 className='m-0'>Recommended Plans</h6>
                                    <button className='plain-button'
                                        onClick={() =>
                                            navigate("/admin/plans-billing", {
                                                state: {
                                                    tenantId: Tenant_Id,
                                                    planId: Plan_Id,
                                                },
                                            })
                                        }>
                                        View All</button>
                                </div>


                                <PlansBilling
                                    viewFromDetails={true}
                                    DetailedPlanId={data?._id}
                                    silentRefreshKey={recommendedPlansRefreshKey}
                                />
                            </section>}
                    </div>
                </div>
                <div className="mobile-view-bottom"></div>

            </div>


            {deleteModalOpen && (
                <>
                    <div className="center-form">
                        <div style={{ maxWidth: '600px' }}>
                            <div className="cf-head">
                                <div>
                                    <h2>{data?.is_active ? 'Deactivate Plan' : 'Delete Plan'}</h2>
                                </div>
                                <button
                                    className="cf-close text-secondary"
                                    onClick={() => {
                                        if (!deleteLoading) {
                                            setDeleteModalOpen(false);
                                            setDeleteError(null);
                                        }
                                    }}
                                >
                                    ✕
                                </button>
                            </div>

                            <div className="cf-body">
                                <p className="fw-semibold text-danger">
                                    Are you sure you want to {data?.is_active ? 'deactivate' : 'delete'} this plan configuration?
                                </p>
                                {data?.is_active ? '' :
                                    <p className="text-secondary small-font">
                                        This will permanently remove <strong>{data?.name}</strong> from your plan list.
                                        Tenants will no longer be able to use this configuration.
                                    </p>}
                                {data?.is_active ? '' :
                                    <p className="text-secondary small-font mb-0">
                                        This action cannot be undone.
                                    </p>}

                                {deleteError && (
                                    <div className="text-danger text-center w-100 fw-bold mt-3">
                                        {deleteError}
                                    </div>
                                )}
                            </div>

                            {/* <div className="cf-body">
                                <p className="fw-semibold text-warning">
                                    Are you sure you want to deactivate this plan?
                                </p>

                                <p className="text-secondary small-font">
                                    Once deactivated, <strong>{data?.name}</strong> will no longer be available
                                    for new subscriptions.
                                </p>

                                <p className="text-secondary small-font mb-0">
                                    Existing tenants currently using this plan may be affected by this change.
                                </p>

                                {deleteError && (
                                    <div className="text-danger text-center w-100 fw-bold mt-3">
                                        {deleteError}
                                    </div>
                                )}
                            </div> */}

                            <div className="cf-footer">
                                <div className="d-a justify-content-between w-100">
                                    <button
                                        className="container-card px-4 py-2 text"
                                        onClick={() => {
                                            setDeleteModalOpen(false);
                                            setDeleteError(null);
                                        }}
                                        disabled={deleteLoading}
                                    >
                                        CANCEL
                                    </button>

                                    <button
                                        className="cf-submit bg-danger px-4"
                                        onClick={handleDeletePlan}
                                        disabled={deleteLoading}
                                    >
                                        {deleteLoading ? "Deactivating…" : data?.is_active ? "Confirm Deactivate" : 'CONFIRM DELETE'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </>
            )}
        </>
    )
}
